import axios from '../Axios';

export default {
  async uploadPic(pic, userId) {
    const postUrl = "/uploads/users/" + userId + "/profile-image";
    const response = await axios.post(postUrl,
      { attachment: pic },
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  }
}